export const AUTOCALL_RENDEMENT_default = [
    {
        barriere_de_protection_du_capital: -60,
        seuil_autocall: 100,
        coupon_conditionnel_maximum: 10,
        coupon_conditionnel_minimum: 5,
        barriere_de_coupon_conditionnel_minimum: -20,
        coupon_garanti: 4
    },
    {
        barriere_de_protection_du_capital: 60,
        seuil_autocall: 100,
        coupon_conditionnel_maximum: 10,
        coupon_conditionnel_minimum: 5,
        barriere_de_coupon_conditionnel_minimum: 80,
        coupon_garanti: 4
    },
    {
        barriere_de_protection_du_capital: 60,
        seuil_autocall: 100,
        coupon_conditionnel_maximum: 10,
        coupon_conditionnel_minimum: 5,
        barriere_de_coupon_conditionnel_minimum: 80,
        coupon_garanti: 4
    },
    {
        barriere_de_protection_du_capital: 60,
        seuil_autocall: 100,
        coupon_conditionnel_maximum: 10,
        coupon_conditionnel_minimum: 5,
        barriere_de_coupon_conditionnel_minimum: 80,
        coupon_garanti: 4
    },
    {
        barriere_de_protection_du_capital: 60,
        seuil_autocall: 100,
        coupon_conditionnel_maximum: 10,
        coupon_conditionnel_minimum: 5,
        barriere_de_coupon_conditionnel_minimum: 80,
        coupon_garanti: 4
    }
]



// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/default/AutocallRendement.ts